import { YStack, XStack, Text } from 'tamagui'
import type { ExerciseSlide as ExerciseSlideType } from '../../../content/decks/types'
import { SlideContainer, SlideInner, getAccentColor } from './shared'

export function ExerciseSlide({ slide }: { slide: ExerciseSlideType }) {
  const accentColor = getAccentColor(slide.accent)
  return (
    <SlideContainer>
      <SlideInner style={{ padding: 'clamp(32px, 6vw, 80px)' }}>
        <XStack gap="$4" alignItems="center">
          <Text
            fontFamily="$heading"
            fontWeight="700"
            color={accentColor}
            style={{ fontSize: 'clamp(24px, 3.5vw, 44px)', lineHeight: '1.2em' }}
          >
            {slide.headline}
          </Text>
          {slide.timeLimit && (
            <YStack
              paddingHorizontal="$3"
              paddingVertical="$1"
              borderRadius="$2"
              borderWidth={1}
              borderColor={accentColor}
            >
              <Text fontFamily="$mono" color={accentColor} style={{ fontSize: 'clamp(10px, 1vw, 14px)' }}>
                {slide.timeLimit}
              </Text>
            </YStack>
          )}
        </XStack>
        <YStack
          borderLeftWidth={3}
          borderLeftColor={accentColor}
          paddingLeft="$5"
          gap="$4"
          marginTop="$4"
        >
          <Text
            fontFamily="$body"
            fontWeight="600"
            color="$textPrimary"
            style={{ fontSize: 'clamp(14px, 1.8vw, 22px)' }}
          >
            {slide.objective}
          </Text>
          <YStack gap="$3">
            {slide.instructions.map((instruction, i) => (
              <XStack key={i} gap="$3" alignItems="flex-start">
                <Text
                  fontFamily="$mono"
                  color={accentColor}
                  style={{ fontSize: 'clamp(12px, 1.4vw, 18px)', width: '24px' }}
                >
                  {i + 1}.
                </Text>
                <Text
                  fontFamily="$body"
                  color="$textSecondary"
                  flex={1}
                  style={{ fontSize: 'clamp(13px, 1.5vw, 20px)', lineHeight: '1.5em' }}
                >
                  {instruction}
                </Text>
              </XStack>
            ))}
          </YStack>
          {slide.deliverable && (
            <XStack gap="$2" alignItems="center" marginTop="$2">
              <Text fontFamily="$mono" color="$orangeSecondary" style={{ fontSize: 'clamp(10px, 1vw, 14px)' }}>
                {'▸'} deliverable:
              </Text>
              <Text
                fontFamily="$mono"
                color="$textMuted"
                fontStyle="italic"
                style={{ fontSize: 'clamp(10px, 1.2vw, 14px)' }}
              >
                {slide.deliverable}
              </Text>
            </XStack>
          )}
        </YStack>
      </SlideInner>
    </SlideContainer>
  )
}
